// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gmy7","index":"styles_index__19uYq"};